var React = require('react');

function IconX (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.808 1.28564H16.3708L10.7717 7.68539L17.3588 16.3938H12.201L8.16142 11.112L3.53914 16.3938H0.97454L6.96345 9.54864L0.644531 1.28564H5.933L9.58455 6.1132L13.808 1.28564ZM12.9084 14.8596H14.3286L5.1614 2.73923H3.63753L12.9084 14.8596Z","fill":"currentColor"}));
}

IconX.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 18 18","fill":"none"};

module.exports = IconX;

IconX.default = IconX;
